// OB-7718: platformBrowserDynamic → platformBrowser (AOT; пакет
// @angular/platform-browser-dynamic удалён из зависимостей)
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

const botUa = [
//    "Google Page Speed Insights",
//    "Chrome-Lighthouse",
    "YandexBot",
    "YandexMobileBot",
    "Googlebot"
];
const botHost = [
    "yandexwebcache.net",
    "webcache.googleusercontent.com"
];
let notfound = true;
if (navigator.userAgent) {
    for (let ua of botUa) {
        if (navigator.userAgent.indexOf(ua) !== -1) {
            notfound = false;
            break;
        }
    }
}
if (location.hostname) {
    for (let hn of botHost) {
        if (location.hostname === hn) {
            notfound = false;
            break;
        }
    }
}
notfound && document.addEventListener('DOMContentLoaded', () => {
     platformBrowser().bootstrapModule(AppBrowserModule).catch(err => console.error(err));
});
